function SimpleObserver() {
    this.handlers = []
}

SimpleObserver.prototype = {
    subscribe(evt, fn) {
        this.handlers.push({ evt, fn })
    },
    unsubscribe(fn) {
        this.handlers = this.handlers.filter((fnc) => fnc !== fn)
    },
    notify(evt) {
        this.handlers.forEach((i) => i.evt === evt && i.fn())
    },
}

export default SimpleObserver
